// extracted by mini-css-extract-plugin
export default {"wrapper":"theme-wrapper-1LCeW"};